import { render, staticRenderFns } from "./MembersReport.vue?vue&type=template&id=2dd35dc6&"
import script from "./MembersReport.vue?vue&type=script&lang=ts&"
export * from "./MembersReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports